import partner_1 from './partner_1.jpg';

export default {
    partner_1
}


// WEBPACK FOOTER //
// ./src/assets/img/llc/partners/index.js